export const iconFontAwesomeHumanitarianShieldDog = (
	<i className="fa-solid fa-shield-dog"></i>
);
